import {ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot} from "@angular/router";
import {inject} from "@angular/core";
import {of} from "rxjs";
import {map} from "rxjs/operators";
import {AuthService} from "../../shared/service/auth.service";

export const customerIdAuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  return authService.customerIdReplay
    .pipe(map(customerId => {
      if (customerId != '' && customerId != null){
        return true;
      }
      return router.parseUrl('auth/request-access') ;
    }));
};

